import React, { useEffect, useState } from "react";
import styles from "./Hero.module.scss";
import homeStyles from "../../../styles/Home.module.scss"
import Image from "next/image";
function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className={styles.heroSection}>
      <div className={styles.backgroundOverlay} />
      <div className={styles.container}>
        <div className={styles.grid}>
          <div
            className={`${styles.leftColumn} ${
              isVisible ? styles.animateLeft : styles.hidden
            }`}
          >
            <div className={styles.content}>
              <div className={"tag"}>
                <span> Next-Generation Commerce</span>
              </div>

              <h1 className="heading" style={{marginBottom:0}}>
              Digitize your wholesale commerce with
                <br />
                <span className={homeStyles["span-gradient"]}>Socommerz B2B</span>
              </h1>
              <p>
              An AI-powered platform with intelligent storefronts, real-time inventory, smart ordering and custom pricing for less manual work and better buyer experiences.
              </p>

            </div>
          </div>

          <div
            className={`${styles.rightColumn} ${
              isVisible ? styles.animateRight : styles.hidden
            }`}
          >
            <div className={styles.imageWrapper}>
              <img
                src="/b2b/hero2.webp"
                alt="AI Shopping Assistant Interface"
                className={styles.image}
              />
        
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
